import { Dialog, useDialog } from "@fpsoftware/mvp";
import { useForm } from "react-hook-form";
import { TbBug } from "react-icons/tb";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { FormGroup } from "@/components/form/FormGroup";
import { TextareaField } from "@/components/form/TextareaField";
import styles from "./BugReportDialog.module.css";

interface BugReportDialogProps {
  screenshot: string;
}

export const BugReportDialog = ({ screenshot }: BugReportDialogProps) => {
  const dialog = useDialog();

  const { handleSubmit, formState, control } = useForm<{
    description: string;
  }>({
    defaultValues: { description: "" },
  });

  const onSubmit = handleSubmit(async ({ description }) => {
    await Api.BugReport({ description, screenshot });
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Report a Bug</Dialog.Header>
      <Dialog.Body>
        <TextareaField
          label="Description"
          name="description"
          control={control}
          rows={4}
          placeholder="Describe what happened and what you expected to happen…"
          required
        />
        <FormGroup label="Screenshot" htmlFor="#">
          <img
            src={screenshot}
            className={styles.screenshot}
            alt="Screenshot of the current page"
          />
        </FormGroup>
      </Dialog.Body>
      <Dialog.Footer>
        <Button variant="ghost" type="button" onClick={() => dialog.close()}>
          Cancel
        </Button>
        <Button icon={TbBug} type="submit" loading={formState.isSubmitting}>
          Submit report
        </Button>
      </Dialog.Footer>
    </form>
  );
};
